import { createContext, useContext } from 'react';
import { assert } from '../../errors';
import { PageMode } from '../../types';
import { isSingleplayer, useCurrentUser } from '../user';

export const PAGE_MODE_MINE_COLOR = '#4B657E';

export type PageModePopoverType = 'private' | 'joint';

interface PageContext {
    pageMode: PageMode;
    setPageMode: (view: PageMode) => void;
    togglePageMode: () => void;
    popover: {
        isOpen: boolean;
        hiddenAccountsCount: number;
        hiddenAccountsType: PageModePopoverType;
    };
    showPopover: (count: number, type: PageModePopoverType) => void;
    hidePopover: () => void;
}

export const PageContext = createContext<PageContext | null>(null);

export const usePageContext = (): PageContext => {
    const ctx = useContext(PageContext);
    assert(ctx, 'Value must be passed to PageContext');
    return ctx;
};

export const usePageModePrefix = (): string => {
    const currentUser = useCurrentUser();
    const { pageMode } = usePageContext();

    return isSingleplayer(currentUser) || pageMode === 'MINE' ? 'MY' : 'OUR';
};
